import PropTypes from 'prop-types';
import { FaStar, FaRegStar } from 'react-icons/fa';
import ResponsiveButton from '../ResponsiveButton/ResponsiveButton';

const ArtistCard = ({ band, onViewProfile, highlight }) => {
  // 1. Mietitään, mitkä kentät tekevät kortista Premiumin
  const isPremium =
    !!band.gallery_images ||
    !!band.audio_tracks ||
    !!band.feedback;

  return (
    <div
      className="relative bg-primary dark:bg-purple-800 shadow-xxl overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl flex flex-col"
      data-aos="zoom-in"
    >
      {/* 2. Viikon artisti -nauha */}
      {highlight && (
        <div className="absolute top-2 left-2 bg-yellow-400 text-black font-customFont1 px-3 py-1 text-sm font-bold rounded z-10 shadow-lg transform -rotate-3 scale-105 flex items-center gap-1">
          <FaStar className="text-yellow-700 drop-shadow-sm" />
          Viikon esiintyjä
        </div>
      )}

      <div className="absolute top-2 right-2 z-10">
        {isPremium ? (
          <div className="px-2 py-1 text-xs font-bold mt-2 font-customFont1 rounded shadow-md bg-purple-600 text-yellow-400 cursor-default rotate-12">
            Premium
          </div>
        ) : (
          <div className="px-2 py-1 text-xs font-bold font-customFont1 rounded shadow-md bg-purple-300 text-black cursor-default rotate-12">
            Basic
          </div>
        )}
      </div>

      {/* 4. Profiilikuva */}
      <img
        src={band.profile_image}
        alt={band.name}
        className="w-full h-[220px] object-cover object-center shadow-md"
      />

      <div className="p-4 flex flex-col flex-grow">
        <h3 className="font-customFont2 text-left text-darkest dark:text-primary text-2xl font-thin leading-[1.2]">
          {band.name}
        </h3>

        {/* Esiintymisalueet ja paikkakunta */}
        {band.performance_regions && (
          <p className="font-customFont1 xxxsm:text-sm xxsm:text-sm
 xsm:text-sm text-lgtext-darkest dark:text-primary mt-1">
            <span className="font-extrabold mr-1">Alueet:</span>
            {band.performance_regions}
          </p>
        )}
        {band.location && (
          <p className="font-customFont1 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg text-darkest dark:text-primary">
            <span className="font-bold mr-1">Kotikaupunki:</span>
            {band.location}
          </p>
        )}

        {/* Genre */}
        {band.genre && (
          <p className="font-customFont1 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg text-darkest dark:text-primary mt-1">
            <span className="font-extrabold mr-1">Genre:</span>
            {band.genre}
          </p>
        )}

        {/* Arvostelut */}
        {band.total_reviews > 0 && typeof band.average_rating === 'number' ? (
          <div className="flex items-center my-4">
            <span className="font-customFont1 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg text-darkest dark:text-primary">
              {band.average_rating.toFixed(1)} / 5
            </span>
            <div className="ml-2 flex">
              {[...Array(5)].map((_, idx) =>
                idx < Math.round(band.average_rating) ? (
                  <FaStar key={idx} className="text-yellow-400" />
                ) : (
                  <FaRegStar key={idx} className="text-gray-400" />
                )
              )}
            </div>
            <span className="font-customFont1 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-bold ml-3 text-darkest dark:text-primary">
              ({band.total_reviews})
            </span>
          </div>
        ) : (
          <p className="font-customFont1 xxxsm:text-sm xxsm:text-sm xsm:text-sm text-lg font-bold my-4 text-darkest dark:text-primary">
            Ei vielä arvosteluja
          </p>
        )}

        {/* 5. Katso profiili -nappi */}
        <div className="mt-auto flex gap-3 justify-center flex-wrap">
          <ResponsiveButton
            variant="artistcardbutton"
            onClick={() => onViewProfile(band.slug)}
          >
            Katso profiili
          </ResponsiveButton>
        </div>
      </div>
    </div>
  );
};

ArtistCard.propTypes = {
  band: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired,
    profile_image: PropTypes.string.isRequired,
    performance_regions: PropTypes.string,
    location: PropTypes.string,
    genre: PropTypes.string,
    total_reviews: PropTypes.number,
    average_rating: PropTypes.number,
    video_link: PropTypes.string,        // käydään läpi Premium‑kentät
    gallery_images: PropTypes.string,
    audio_tracks: PropTypes.string,
    feedback: PropTypes.string,
    slug: PropTypes.string.isRequired,
  }).isRequired,
  onViewProfile: PropTypes.func,
  highlight: PropTypes.bool,
};

export default ArtistCard;
